<template>
  <Modal :value="value" title="反馈建议" class="vertical-center-modal" :width="480"
    footer-hide @on-visible-change="onVisible">
    <Tabs v-model="tab">
      <TabPane label="历史记录" name="history">
        <div class="history-con">
          <div v-if="!history.length" class="nodata">暂无数据</div>
          <div v-for="h in history" :key="h.id" class="h-item">
            <span class="t">{{ h.time }}</span>
            <span class="c">{{ h.content }}</span>
            <Tag :color="h.replied ? 'green' : 'default'">{{ h.replied ? '已回复' : '待处理' }}</Tag>
          </div>
        </div>
      </TabPane>
      <TabPane label="创建" name="create">
        <Form :label-width="70">
          <FormItem label="问题描述">
            <Input v-model="content" type="textarea" :rows="4" placeholder="请描述您遇到的问题" />
          </FormItem>
          <FormItem label="截图">
            <Upload action="" :before-upload="beforeUpload" accept="image/*">
              <Button icon="ios-cloud-upload-outline">上传图片</Button>
            </Upload>
            <div v-if="imgName" class="img-name">{{ imgName }}</div>
          </FormItem>
        </Form>
        <div class="create-foot">
          <dialog-footer confirm-text="提交" @cancel="close" @confirm="submit" />
        </div>
      </TabPane>
    </Tabs>
  </Modal>
</template>

<script>
export default {
  name: 'FeedbackDialog',
  props: { value: { type: Boolean, default: false } },
  data() {
    return {
      tab: 'history',
      content: '',
      imgName: '',
      history: []
    }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.content = ''; this.imgName = ''; this.tab = 'history'; this.$emit('input', false) },
    beforeUpload(file) { this.imgName = file.name; return false }, // 阻止自动上传,交给业务
    submit() {
      if (!this.content.trim()) { this.$Message.warning('请填写问题描述'); return }
      this.$Message.success('反馈已提交(待接口)')
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
.img-name { color: #888; font-size: 12px; margin-top: 6px; }
.history-con { max-height: 160px; overflow: auto; }
.h-item { display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px solid #f0f0f0; font-size: 12px; }
.h-item .t { color: #999; }
.h-item .c { flex: 1; }
.nodata { color: #999; text-align: center; padding: 20px 0; }
.create-foot { margin-top: 12px; }
</style>
